
























import FragebogenApi from "../../services/api/Fragebogen";
import format from "date-fns/format";
import deLocale from "date-fns/locale/de";
export default {
  props: {
    fragebogenList:Array,
    patientObject:Object
  },  
  data: function() {
    return {
      items: [],
      hasDraftItem: false,
    };
  },
  methods: {
    openCurrentuserProfile(){
        this.$router
        .push({
          name: "NutzerProfil",
          params: { userId: this.patientObject.userId },
        })
        .catch(() => {});
    },
    changeSelection: function(item: any) {
      this.$emit("update:selection", item);
    },
    getDraftStatus: function(item: any) {
      if (item.veroeffentlicht === null) {
        this.hasDraftItem = true;
        return "(Entwurf)";
      }
      return "";
    },
    getGermanDate: function(item: any) {
      if (item.veroeffentlicht === null) {
        return "";
      }
      const date = new Date(item.veroeffentlicht);
      return format(date, "P", { locale: deLocale });
    },
    newFragebogen: function() {
      if(this.patientObject == null){
        alert('Kein Patientenobjekt verfügbar');
        return;
      }
      FragebogenApi.createNewPatientFragebogen(this.patientObject.id).then(response => {
        if (response.antworten === null) {
          response.antworten = [];
        }

        this.fragebogenList.push(response);
        this.fragebogenList.sort(function(x: any, y: any) {
          if (x.veroeffentlicht === null) {
            return -1;
          }
          if (x.veroeffentlicht < y.veroeffentlicht) {
            return 1;
          }
          if (x.veroeffentlicht > y.veroeffentlicht) {
            return -1;
          }
          return 0;
        });
        this.changeSelection(response);
      });
    },
  },
};
